/**
 * Inline Email Capture — Layer D
 * File: assets/inline-capture.js
 *
 * Depends on: lead-capture-utils.js (LiftSetsCapture global)
 * 
 * Embedded capture within page content.
 * Validates email + blocks disposables → lets Shopify form submit naturally.
 * On page reload after submit, shows success message.
 * Hidden entirely if user has already submitted any capture form.
 */

(function () {
  'use strict';

  var LC = window.LiftSetsCapture;
  if (!LC) return;

  /* ============================================================
     DOM REFERENCES
     ============================================================ */

  var container  = document.getElementById('ls-inline-capture');
  if (!container) return;

  var form       = document.getElementById('ls-inline-form');
  var emailInput = document.getElementById('ls-inline-email');
  var successEl  = document.getElementById('ls-inline-success');
  var innerEl    = container.querySelector('.ls-inline-inner');

  /* ============================================================
     ALREADY SUBMITTED — Show success or hide entirely
     ============================================================ */

  if (LC.hasSubmitted()) {
    // If they just submitted this form (flag set before page refresh)
    if (LC.getLocal('liftsets_inline_just_submitted')) {
      LC.removeLocal('liftsets_inline_just_submitted');
      if (innerEl) innerEl.style.display = 'none';
      if (successEl) successEl.style.display = 'flex';
    } else {
      // Previously submitted via another form — hide inline capture
      container.style.display = 'none';
    }
    return;
  }

  /* ============================================================
     FORM SUBMIT HANDLER
     ============================================================ */

  async function handleSubmit(e) {
    var email = emailInput.value.trim().toLowerCase();

    // Validate
    if (!LC.isValidEmail(email)) {
      e.preventDefault();
      emailInput.classList.add('ls-input-error');
      emailInput.setAttribute('placeholder', 'Valid email required');
      setTimeout(function () {
        emailInput.classList.remove('ls-input-error');
        emailInput.setAttribute('placeholder', 'Enter your email');
      }, 2000);
      return;
    }

    // Check disposable
    await LC.loadDisposableDomains();
    if (LC.isDisposableEmail(email)) {
      e.preventDefault();
      emailInput.value = '';
      emailInput.classList.add('ls-input-error');
      emailInput.setAttribute('placeholder', 'Use a real email');
      setTimeout(function () {
        emailInput.classList.remove('ls-input-error');
        emailInput.setAttribute('placeholder', 'Enter your email');
      }, 2000);
      return;
    }

    // ✅ Valid — save state before page refreshes
    LC.markSubmitted();
    LC.setLocal('liftsets_inline_just_submitted', '1');
    LC.fireEvent('popup_email_submitted', { popup_type: 'inline-capture', buyer_type: '' });
    LC.fireEnhancedConversion(email);

    // Let Shopify form submit naturally (CAPTCHA handled)
  }

  /* ============================================================
     EVENT LISTENERS
     ============================================================ */

  form.addEventListener('submit', handleSubmit);

  // Clear error styling on input
  emailInput.addEventListener('input', function () {
    emailInput.classList.remove('ls-input-error');
  });

})();